var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":'status' + _vm.status.id}},_vm._l((_vm.statusRecords),function(record){return _c('lazy-render',{key:record.id,attrs:{"min-height":128,"unrender":"","data-record-id":record.id}},[_c('active-record-item',{attrs:{"record":record,"acceptable-time":_vm.status.acceptable_time}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }